import { NgModule } from '@angular/core';


import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzModalModule } from 'ng-zorro-antd/modal';

import { NzLayoutModule } from 'ng-zorro-antd/layout';

import { NzIconModule, NZ_ICONS } from 'ng-zorro-antd/icon';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { IconDefinition } from '@ant-design/icons-angular';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';

// TODO switch this to only import required icons
const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(
  key => antDesignIcons[key]
);

// TODO change icons to only the used icons

const Modules = [
  NzSkeletonModule,
  NzLayoutModule,
  NzButtonModule,
  NzCheckboxModule,
  NzRadioModule,
  NzInputModule,
  NzInputNumberModule,
  NzIconModule,
  NzSelectModule,
  NzDatePickerModule,
  NzDrawerModule,
  NzTagModule,
  NzCardModule,
  NzProgressModule,
  NzGridModule,
  NzSpinModule,
  NzSpaceModule,
  NzModalModule,
  NzCollapseModule,
  NzListModule,
  NzDividerModule,
  NzEmptyModule,
  NzFormModule,
  NzAffixModule,
  NzPageHeaderModule,
  NzResultModule,
  NzTabsModule,
  NzStepsModule,
  NzToolTipModule
];

@NgModule({
  imports: Modules,
  exports: Modules,
  providers: [{ provide: NZ_ICONS, useValue: icons }]
})
export class AngularAntdModule { }
